import { render, staticRenderFns } from "./TableOrderDropdown.vue?vue&type=template&id=2ae795ed&scoped=true&"
import script from "./TableOrderDropdown.vue?vue&type=script&lang=ts&"
export * from "./TableOrderDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae795ed",
  null
  
)

export default component.exports